import React, { useContext } from 'react';
import { Table, Button } from 'react-bootstrap';
import { ThemeContext } from '../context/ThemeContext';


function DocumentTable({ documents, onPreview }) {
  const { darkMode } = useContext(ThemeContext);

  // Funzione per formattare la data nel formato dd-mm-YYYY
  const formatDate = (dateString) => {
    if (!dateString) return '-';
    
    try {
      // Prova diversi formati di input
      let date;
      
      // Se la data è già in formato ISO (YYYY-MM-DD) o simile
      if (dateString.includes('-') && dateString.length === 10) {
        date = new Date(dateString);
      }
      // Se la data è in formato DD/MM/YYYY
      else if (dateString.includes('/')) {
        const parts = dateString.split('/');
        if (parts.length === 3) {
          // Assumendo DD/MM/YYYY
          date = new Date(parts[2], parts[1] - 1, parts[0]);
        }
      }
      // Se la data è in formato YYYYMMDD (8 caratteri)
      else if (dateString.length === 8 && !isNaN(dateString)) {
        const year = dateString.substring(0, 4);
        const month = dateString.substring(4, 6);
        const day = dateString.substring(6, 8);
        date = new Date(year, month - 1, day);
      }
      // Prova parsing diretto
      else {
        date = new Date(dateString);
      }
      
      // Verifica se la data è valida
      if (isNaN(date.getTime())) {
        return dateString; // Ritorna il valore originale se non riesce a parsare
      }
      
      // Formatta in dd-mm-YYYY
      const day = String(date.getDate()).padStart(2, '0');
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const year = date.getFullYear();
      
      return `${day}-${month}-${year}`;
    } catch (error) {
      console.warn('Errore nel parsing della data:', dateString, error);
      return dateString; // Ritorna il valore originale in caso di errore
    }
  };


  return (
    <Table responsive striped bordered hover variant={darkMode ? 'dark' : 'light'}>
      <thead>
        <tr>
          <th>Causale Documento</th>
          <th>N Doc</th>
          <th>Data Documento</th>
          <th className="text-center">Azioni</th>
        </tr>
      </thead>
      <tbody>
        {documents.length > 0 ? (
          documents.map((doc) => (
            <tr key={doc.n_bolla}>
              <td>{doc.nomecausale}</td>  
              <td>{doc.n_bolla}</td>
              <td>{formatDate(doc.data_cons)}</td>
              <td className="text-center">
                <Button
                  variant="primary"
                  size="sm"
                  onClick={() => onPreview && onPreview(doc.tblocco)}
                >
                  Anteprima
                </Button>
              </td>
            </tr>
          ))
        ) : (
          <tr>
            <td colSpan="4" className="text-center py-3">
              Nessun documento disponibile
            </td>
          </tr>
        )}
      </tbody>
    </Table>
  );
}

export default DocumentTable;